// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import CiqlerDetail from './Ciqler/CiqlerDetail';
import CanvasBrewDetail from './CanvasBrew/CanvasBrewDetail';
import DriveGuardDetail from './DriveGuard/DriveGuardDetail'
import GroNutruiDetail from './GroNutrui/GroNutruiDetail'
import ReportingToolDetail from './ReportingTool/ReportingToolDetail'
import SousChefDetail from './SousChef/SousChefDetail'
import Main from './main'
// Import other project detail components as needed

function App() {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/ciqler" element={<CiqlerDetail />} />
          <Route path="/canvasbrew" element={<CanvasBrewDetail />} />
          <Route path="/reportingtool" element={<ReportingToolDetail />} />
          <Route path="/gronuturi" element={<GroNutruiDetail />} />
          <Route path="/driveguard" element={<DriveGuardDetail />} />
          <Route path="/souschef" element={<SousChefDetail />} />
          <Route path="/" element={<Main />} />


          {/* Add routes for other project detail components */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
